/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ateliere_Connect_Caption_Name_RequiredInputs */



/**
* | output |
* | --- |
* | "File name cannot be empty" |
*
* @param {Ateliere_Connect_Caption_Name_RequiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ateliere_connect_caption_name_required = /** @type {((inputs?: Ateliere_Connect_Caption_Name_RequiredInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ateliere_Connect_Caption_Name_RequiredInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le nom du fichier ne peut pas être vide")
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Dateiname darf nicht leer sein.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il nome del file non può essere vuoto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Имя файла не может быть пустым.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El nombre del archivo no puede estar vacío")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文件名不能为空。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ファイル名は空にできません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ाइल का नाम खाली नहीं हो सकता")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O nome do arquivo não pode estar vazio.")
	return /** @type {LocalizedString} */ ("File name cannot be empty")
});